/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { makeStyles } from '@mui/styles';

export const useOidcProviderButtonStyles = makeStyles(() => ({
  textNoWrap: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',
    width: 'fit-content',
    maxWidth: '70%',
    textAlign: 'center',
  },
  thumbnail: {
    outline: '2px solid white',
    outlineOffset: '0px',
  },
}));
